import React from "react";
import { useTranslation } from "react-i18next";
import PageHeaderSolutions from "../components/PageHeaderSolutions";
import { CaretRightFilled } from "@ant-design/icons";
import production_time_prediction from "../assets/images/applications/production_time_prediction.jpg";
import IndustryBanner from "../appareas/IndustryBanner";
import RegressionModelChart from "./charts/RegressionModelChart"

const ProductionTimePrediction = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeaderSolutions></PageHeaderSolutions>
      <section className="mt-24 w-full h-full relative bg-center bg-cover p-5 border-2 border-blue-900 rounded-lg bg-white">
        <div> <IndustryBanner></IndustryBanner> </div>
        <div className="items-center text-center">
          <h3 className="mt-2 text-blue-900 text-4xl font-semibold mb-2">
            {t("production_time_prediction")}
          </h3>
        </div>

        <p className="text-2xl">
          <CaretRightFilled />
          {t("production_time_prediction_description1")}
        </p>
        <p className="text-2xl">
          <CaretRightFilled />
          {t("production_time_prediction_description2")}
        </p>
        <p className="text-2xl">
          <CaretRightFilled />
          {t("production_time_prediction_description3")}
        </p>

        {/* <img src={production_time_prediction} width={2000} height={1200} alt="production_time_prediction" /> */}
      <RegressionModelChart></RegressionModelChart>
      </section>
    </>
  );
};

export default ProductionTimePrediction;
